import { motion } from "framer-motion";
import { storyContent } from "@/data/dummy";
export const Story = () => {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} transition={{
    duration: 0.8
  }} viewport={{
    once: true
  }} className="py-20 px-4 bg-white">
      <div className="max-w-5xl mx-auto">
        {/* Section Title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} viewport={{
        once: true
      }} className="mb-10 space-y-4">
          <h2 className="font-sans font-normal tracking-tight text-3xl md:text-4xl text-foreground">What We're Doing and Why It Matters</h2>
        </motion.div>

        {/* Story Content - Two Main Sections */}
        <div className="space-y-16">
          {/* First Section: First 2 paragraphs with mother & baby image */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div 
              initial={{ opacity: 0, y: 20 }} 
              whileInView={{ opacity: 1, y: 0 }} 
              transition={{ delay: 0.3, duration: 0.6 }} 
              viewport={{ once: true }} 
              className="space-y-6"
            >
              {/* First paragraph */}
              <div className="text-base leading-relaxed text-foreground">
                {storyContent.paragraphs[0].split('\n').map((line, lineIndex) => (
                  <span key={lineIndex}>
                    {line.split(/(\[.*?\]\(.*?\))/).map((part, partIndex) => {
                      const linkMatch = part.match(/\[(.*?)\]\((.*?)\)/);
                      if (linkMatch) {
                        const [, text, url] = linkMatch;
                        return (
                          <a key={partIndex} href={url} target="_blank" rel="noopener noreferrer" className="text-primary hover:text-accent underline-offset-4 hover:underline">
                            {text}
                          </a>
                        );
                      }
                      return part;
                    })}
                    {lineIndex < storyContent.paragraphs[0].split('\n').length - 1 && <br />}
                  </span>
                ))}
              </div>

              {/* Second paragraph */}
              <div className="text-base leading-relaxed text-foreground">
                {storyContent.paragraphs[1].split('\n').map((line, lineIndex) => (
                  <span key={lineIndex}>
                    {line.split(/(\[.*?\]\(.*?\))/).map((part, partIndex) => {
                      const linkMatch = part.match(/\[(.*?)\]\((.*?)\)/);
                      if (linkMatch) {
                        const [, text, url] = linkMatch;
                        return (
                          <a key={partIndex} href={url} target="_blank" rel="noopener noreferrer" className="text-primary hover:text-accent underline-offset-4 hover:underline">
                            {text}
                          </a>
                        );
                      }
                      return part;
                    })}
                    {lineIndex < storyContent.paragraphs[1].split('\n').length - 1 && <br />}
                  </span>
                ))}
              </div>

              {/* Third paragraph */}
              <div className="text-base leading-relaxed text-foreground">
                {storyContent.paragraphs[2].split('\n').map((line, lineIndex) => (
                  <span key={lineIndex}>
                    {line}
                    {lineIndex < storyContent.paragraphs[2].split('\n').length - 1 && <br />}
                  </span>
                ))}
              </div>

              {/* Fourth paragraph */}
              <div className="text-base leading-relaxed text-foreground">
                {storyContent.paragraphs[3].split('\n').map((line, lineIndex) => (
                  <span key={lineIndex}>
                    {line.split(/(\[.*?\]\(.*?\))/).map((part, partIndex) => {
                      const linkMatch = part.match(/\[(.*?)\]\((.*?)\)/);
                      if (linkMatch) {
                        const [, text, url] = linkMatch;
                        return (
                          <a key={partIndex} href={url} target="_blank" rel="noopener noreferrer" className="text-primary hover:text-accent underline-offset-4 hover:underline">
                            {text}
                          </a>
                        );
                      }
                      return part;
                    })}
                    {lineIndex < storyContent.paragraphs[3].split('\n').length - 1 && <br />}
                  </span>
                ))}
              </div>

            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
              viewport={{ once: true }}
              className="relative flex items-center justify-center"
            >
              <img 
                src="/images/46427d6b-a649-4633-8ee6-c901cbd3aeda.png"
                alt="Mother holding baby"
                className="w-full max-h-[550px] object-cover rounded-lg shadow-lg"
              />
            </motion.div>
          </div>

          {/* Second Section: Remaining paragraphs with powder image */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5, duration: 0.6 }}
              viewport={{ once: true }}
              className="relative flex items-center justify-center h-full order-2 md:order-1"
            >
              <img 
                src="/images/10cbbde8-6249-4866-aaf6-5e1b55a70dfc.png"
                alt="Baby being bottle-fed"
                className="w-full h-full max-h-[530px] object-cover rounded-lg shadow-lg"
              />
            </motion.div>
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }} 
              whileInView={{ opacity: 1, y: 0 }} 
              transition={{ delay: 0.6, duration: 0.6 }} 
              viewport={{ once: true }}
              className="space-y-6 order-1 md:order-2"
            >
              {/* Sixth paragraph */}
              <div className="text-base leading-relaxed text-foreground">
                {storyContent.paragraphs[4].split('\n').map((line, lineIndex) => (
                  <span key={lineIndex}>
                    {line.split(/(\[.*?\]\(.*?\))/).map((part, partIndex) => {
                      const linkMatch = part.match(/\[(.*?)\]\((.*?)\)/);
                      if (linkMatch) {
                        const [, text, url] = linkMatch;
                        return (
                          <a key={partIndex} href={url} target="_blank" rel="noopener noreferrer" className="text-primary hover:text-accent underline-offset-4 hover:underline">
                            {text}
                          </a>
                        );
                      }
                      return part;
                    })}
                    {lineIndex < storyContent.paragraphs[4].split('\n').length - 1 && <br />}
                  </span>
                ))}
              </div>


            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>;
};